import React, { Component } from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  elevated?: boolean;
  bordered?: boolean;
  as?: keyof JSX.IntrinsicElements;
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
  'aria-label'?: string;
}
export function Card({
  children,
  className = '',
  elevated = false,
  bordered = false,
  as: Component = 'div',
  onClick,
  role,
  tabIndex,
  'aria-label': ariaLabel
}: CardProps) {
  const baseClasses = 'bg-[#F7F7F5] rounded-lg transition-all duration-200';
  const elevatedClasses = elevated ? 'shadow-lg hover:shadow-xl' : 'shadow-sm';
  const borderedClasses = bordered ? 'border border-[#D8D8D4]' : '';
  const clickableClasses = onClick ? 'cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B08D57] focus-visible:ring-offset-2' : '';
  return <Component className={[baseClasses, elevatedClasses, borderedClasses, clickableClasses, className].join(' ')} onClick={onClick} role={role} tabIndex={tabIndex} aria-label={ariaLabel} data-id="element-604">
      {children}
    </Component>;
}
interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}
export function CardHeader({
  children,
  className = ''
}: CardHeaderProps) {
  return <div className={`p-6 pb-0 ${className}`} data-id="element-605">{children}</div>;
}
interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}
export function CardBody({
  children,
  className = ''
}: CardBodyProps) {
  return <div className={`p-6 ${className}`} data-id="element-606">{children}</div>;
}
interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}
export function CardFooter({
  children,
  className = ''
}: CardFooterProps) {
  return <div className={`px-6 pb-6 pt-0 border-t border-[#D8D8D4] mt-4 pt-4 ${className}`} data-id="element-607">
      {children}
    </div>;
}